import _extends from "@babel/runtime/helpers/extends";
import { COUNTRY_CODES, mapSubdivisionReplacedBy } from '@wix/form-multiline-address';
import { getCountryByShortKey } from '@wix/locale-dataset-javascript';
import React, { useMemo } from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useTranslation } from '../../../contexts/translation-context';
import { useAddressLabel } from '../../../hooks/use-address-label';
import { createOption } from '../../../ui/autocomplete/autocomplete-wut';
import { DropdownAutocompleteWUT } from '../../../ui/dropdown-autocomplete';
import { useCountryCode } from '../../multiline-address/multiline-address/country-code-context';
export const MlaSubdivisionWUT = props => {
  const fieldType = FIELD_TYPES.MLA_SUBDIVISION;
  const {
    t
  } = useTranslation();
  const label = useAddressLabel('subdivision');
  const countryCode = useCountryCode();
  const countryCodeAlpha3 = countryCode ? COUNTRY_CODES[countryCode] : undefined;
  const country = countryCode && getCountryByShortKey(countryCode);
  const subdivisionOptions = useMemo(() => {
    var _country$subdivisions;
    const subdivisions = mapSubdivisionReplacedBy((country == null || (_country$subdivisions = country.subdivisions) == null ? void 0 : _country$subdivisions.list) || [], countryCodeAlpha3);
    return (subdivisions || []).map(subdivision => createOption({
      value: t(subdivision.displayName),
      id: subdivision.key
    })).sort((a, b) => a.value.localeCompare(b.value));
  }, [countryCodeAlpha3, t, country]);
  return /*#__PURE__*/React.createElement(DropdownAutocompleteWUT, _extends({}, props, {
    fieldType: fieldType,
    label: label,
    options: subdivisionOptions,
    countryCode: countryCode
  }));
};
//# sourceMappingURL=mla-subdivision-wut.js.map